import { useNavigate } from 'react-router-dom';
import { useAppStore } from '@/store/AppStore';

interface Kpi {
  label: string;
  sub: string;
  value: number;
  path: string;
  icon: string;
  iconClass: string;
}

export default function KpiCards() {
  const { requests, quotes, jobs } = useAppStore();
  const navigate = useNavigate();

  const awaitingReplyRequests = requests.filter((r) => r.status === 'Müşteri Cevabı Bekleniyor').length;
  const awaitingReplyQuotes = quotes.filter((q) => q.status === 'Cevap Bekleniyor').length;
  const videoWaitingQuote = requests.filter(
    (r) => r.videoStatus === 'Video Geldi' && ['Video Geldi', 'Değerlendiriliyor', 'Teklif Hazırlanacak'].includes(r.status),
  ).length;
  const pendingQuotes = quotes.filter((q) =>
    ['Cevap Bekleniyor', 'Müşteriye Gönderildi', 'Hazırlandı', 'Revize İstendi'].includes(q.status),
  ).length;
  const followToday = requests.filter((r) => r.priority === 'Yüksek').length;
  const delayed = requests.filter((r) => ['Ulaşılamadı'].includes(r.status)).length;

  const kpis: Kpi[] = [
    {
      label: "Bugünkü İşler",
      sub: 'Planlanan iş sayısı',
      value: jobs.length,
      path: '/bugunun-isleri',
      icon: 'ri-calendar-check-line',
      iconClass: 'bg-primary-50 text-primary-600',
    },
    {
      label: 'Bekleyen Teklifler',
      sub: 'Hazırlanan / gönderilen',
      value: pendingQuotes,
      path: '/teklifler',
      icon: 'ri-file-text-line',
      iconClass: 'bg-primary-50 text-primary-600',
    },
    {
      label: 'Video Geldi — Teklif Bekliyor',
      sub: 'Aksiyon gerektiriyor',
      value: videoWaitingQuote,
      path: '/teklif-talepleri',
      icon: 'ri-video-line',
      iconClass: 'bg-accent-100 text-accent-700',
    },
    {
      label: 'Müşteri Cevabı Bekleyen',
      sub: 'Teklif yanıtı bekleniyor',
      value: awaitingReplyRequests + awaitingReplyQuotes,
      path: '/takip',
      icon: 'ri-chat-3-line',
      iconClass: 'bg-amber-50 text-amber-600',
    },
    {
      label: 'Bugün Takip Edilecek',
      sub: 'Öncelikli talepler',
      value: followToday,
      path: '/takip',
      icon: 'ri-notification-3-line',
      iconClass: 'bg-red-50 text-red-600',
    },
    {
      label: 'Geciken İşlem',
      sub: 'Müdahale gerekiyor',
      value: delayed,
      path: '/teklif-talepleri',
      icon: 'ri-alert-line',
      iconClass: 'bg-red-50 text-red-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {kpis.map((kpi) => (
        <button
          key={kpi.label}
          type="button"
          onClick={() => navigate(kpi.path)}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-white p-4 text-left transition-colors hover:border-primary-200 hover:bg-background-50"
        >
          <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${kpi.iconClass}`}>
            <i className={`${kpi.icon} text-xl`} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="font-heading text-2xl font-bold leading-none text-foreground-950">
              {kpi.value}
            </div>
            <div className="mt-1 truncate text-[13px] font-semibold text-foreground-800">{kpi.label}</div>
            <div className="truncate text-[11px] text-foreground-500">{kpi.sub}</div>
          </div>
          <i className="ri-arrow-right-s-line text-lg text-foreground-300 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
        </button>
      ))}
    </div>
  );
}